<template>
  <div>
    <router-view v-if="isLoginRoute" />
    <v-container v-else fluid :class="isFullWidth ? 'pa-0' : 'pad'">
      <template v-if="isFullWidth">
        <router-view />
      </template>
      <v-row v-else justify="center">
        <v-col cols="12" md="11" lg="10">
          <router-view />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpers from '@/mixins/helpers';
export default {
  mixins:[helpers],
  created() {
    this.helpers;
  },
  computed: {
    isLoginRoute() {
      return this.$route.name === 'Login' || this.$route.name === 'login' || this.$route.path === '/' || this.$route.path === '/login';
    },
    isFullWidth() {
      // Apply full width layout for Dashboard, Login and Vehicles
      return (
        this.$route.path.includes("/dashboard") ||
        this.$route.name === "Login" ||
        this.$route.path === "/login" ||
        this.$route.path === "/" ||
        this.$route.path.includes("/vehicles-manager") ||
        this.$route.path.includes("/proprietario") ||
        this.$route.path.includes("/locador") ||
        this.$route.path.includes("/tce") ||
        this.$route.path.includes("/attendance-types") ||
        this.$route.path.includes("/settings/logs") ||
        this.$route.path.includes("/fuels-types") ||
        this.$route.path.includes("/consumption-types") ||
        this.$route.path.includes("/bonds-types") ||
        this.$route.path.includes("/bidding") ||
        this.$route.path.includes("/providers-manager") ||
        this.$route.path.includes("/attendants-manager") ||
        this.$route.path.includes("/users-manager") ||
        this.$route.path.includes("/access-groups") ||
        this.$route.path.includes("/prefectures-manager") ||
        this.$route.path.includes("/drivers-manager") ||
        this.$route.path.includes("/supplies-manager") ||
        this.$route.path.includes("/conferences") ||
        this.$route.path.includes("/report") ||
        this.$route.path.includes("/blocked") ||
        this.$route.path.includes("/readjust") ||
        this.$route.path.includes("/retroactivity") ||
        this.$route.path.includes("/authorizations") ||
        this.$route.path.includes("/extra") ||
        this.$route.path.includes("/billings") ||
        this.$route.path.includes("/nfe") ||
        this.$route.path.includes("/providers-manager") ||
        this.$route.path.includes("/parts-and-services/nf") ||
        this.$route.path.includes("/parts-and-services/os") ||
        this.$route.path.includes("/parts-and-services/os-release") ||
        this.$route.path.includes("/parts-and-services/providers-manager") ||
        this.$route.path.includes("/parts-and-services/report")
      );
    },
    isDashboard() {
      return this.$route.path.includes('/dashboard');
    }
  }
};
</script>

<style scoped>
.pad {
  padding: 20px;
}
</style>
